import OBTFormPanel from './OBTFormPanel';
export default OBTFormPanel;
